module.exports = require("core-js/library/fn/object/get-prototype-of");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/get-prototype-of.js